import { ChangeEventsReadableStream } from "@hds/entity-lib";

class DeltaServerChangeEventsReadableStream extends ChangeEventsReadableStream {
    #_deltaServerClient;
    #_topic;
    constructor(deltaServerClient, topic, projection = undefined) {
        super(projection);
        this.#_deltaServerClient = deltaServerClient;
        this.#_topic = topic;
    }
    /*****************************************************************/
    /* START ChangeEventsReadableStream OVERRIDDEN METHODS */
    /*****************************************************************/
    async _start(controller) {
        try {
            this.#_deltaServerClient.addListener('error', this._onDeltaServerError = this._onDeltaServerError.bind(this));
            this.#_deltaServerClient.addListener('close', this._onDeltaServerClose = this._onDeltaServerClose.bind(this));
            if (this._projection) {
                this.#_deltaServerClient.subscribeToTopicWithProjection(this.#_topic, this._projection, this._onDeltaServerTopicMessage = this._onDeltaServerTopicMessage.bind(this));
            }
            else {
                this.#_deltaServerClient.subscribeToTopic(this.#_topic, this._onDeltaServerTopicMessage = this._onDeltaServerTopicMessage.bind(this));
            }
        }
        catch (initializationError) {
            this.destroy(initializationError);
        }
        await super._start(controller);
    }
    async _pull(controller) {
        // This is a "Push" style stream so _pull is not used
    }
    async _cancel(reason) {
        await this.#_unregisterDeltaServerListeners();
        this.#_deltaServerClient = null;
        return super._cancel(reason);
    }
    /*****************************************************************/
    /* END ChangeEventsReadableStream OVERRIDDEN METHODS */
    /* START DELTA SERVER CLIENT HANDLERS */
    /*****************************************************************/
    _onDeltaServerClose(closeEvent) {
        const err = new Error('DELTA_SERVER_CLIENT_CLOSE');
        err.code = 'DELTA_SERVER_CLIENT_CLOSE';
        //Why the socket closed, so a failure listener can tell a refused credential from a dead server
        err.closeCode = closeEvent?.code;
        this.destroy(err);
    }
    _onDeltaServerError(deltaServerClientError) {
        this.destroy(deltaServerClientError);
    }
    _onDeltaServerTopicMessage(event) {
        try {
            const changeEvent = event?.changeEvent;
            switch (changeEvent?.operationType) {
                case "insert":
                    delete changeEvent.fullDocument._id;
                    this._controller.enqueue({
                        type: 'create',
                        id: changeEvent.documentKey._id,
                        document: changeEvent.fullDocument
                    });
                    break;
                case "replace":
                case "update":
                    // The document was gone by the time the server read it; the delete that follows reports it
                    if (!changeEvent.fullDocument) { break; }
                    delete changeEvent.fullDocument._id;
                    this._controller.enqueue({
                        type: 'update',
                        id: changeEvent.documentKey._id,
                        document: changeEvent.fullDocument
                    });
                    break;
                case "delete":
                    this._controller.enqueue({
                        type: 'delete',
                        id: changeEvent.documentKey._id
                    })
                    break;
            }
        }
        catch (onChangeErr) {
            this.destroy(onChangeErr);
        }
    }
    /*****************************************************************/
    /* END DELTA SERVER CLIENT HANDLERS */
    /*****************************************************************/
    async #_unregisterDeltaServerListeners() {
        this.#_deltaServerClient.removeListener('error', this._onDeltaServerError);
        this.#_deltaServerClient.removeListener('close', this._onDeltaServerClose);
        if (this._projection) {
            this.#_deltaServerClient.unsubscribeFromTopicWithProjection(this.#_topic, this._projection, this._onDeltaServerTopicMessage);
        }
        else {
            this.#_deltaServerClient.unsubscribeFromTopic(this.#_topic, this._onDeltaServerTopicMessage);
        }
    }
    async destroy(err) {
        await this.#_unregisterDeltaServerListeners();
        await super.destroy(err);
    }
    get deltaServerClient() {
        return this.#_deltaServerClient;
    }
}
export { DeltaServerChangeEventsReadableStream };
export default DeltaServerChangeEventsReadableStream;